import { render, staticRenderFns } from "./RefundView.vue?vue&type=template&id=2b141122&"
import script from "./RefundView.vue?vue&type=script&lang=js&"
export * from "./RefundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports